import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Consent = { get: () => unknown; save: (c: { analytics: boolean; marketing: boolean }) => void };

export function ConsentBanner() {
  const { t } = useTranslation();
  const consent = (window as unknown as { dgConsent?: Consent }).dgConsent;
  const [open, setOpen] = useState(() => !!consent && !consent.get());
  if (!open || !consent) return null;
  const choose = (yes: boolean) => {
    consent.save({ analytics: yes, marketing: yes });
    setOpen(false);
  };
  return (
    <section className="consent card" aria-labelledby="consent-title">
      <h2 id="consent-title">{t('consent.title')}</h2>
      <p className="muted">{t('consent.text')}</p>
      <div className="row">
        <button className="btn btn--ghost" onClick={() => choose(false)}>{t('consent.reject')}</button>
        <button className="btn" onClick={() => choose(true)}>{t('consent.accept')}</button>
      </div>
    </section>
  );
}
